import { useState } from "react";
import { useDeleteResourceRequest } from "../mutations";

export const useDeleteRequest = ({ onSuccess }: { onSuccess: () => void }) => {

    const [deleting, setDeleting] = useState(false);
    const [deleteError, setDeleteError] = useState<string | null>(null);

    const deleteMaterialReq = useDeleteResourceRequest();

    const handleDelete = async ({ requestId }: { requestId: string | null }) => {
        if (!requestId) return;
        setDeleting(true);
        setDeleteError(null);
        try {
            await deleteMaterialReq.mutateAsync({ id: requestId });
            onSuccess();
        } catch (error) {
            setDeleteError("Failed to delete material request.");
        } finally {
            setDeleting(false);
        }
    }

    return {
        deleting,
        deleteError,
        handleDelete
    }

}
